import script from "./AgentProfileView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentProfileView.vue?vue&type=script&setup=true&lang=js"

import "./AgentProfileView.vue?vue&type=style&index=0&id=39e7c1bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39e7c1bc"]])

export default __exports__